import { useState, useEffect } from "react";
import { Phone } from "lucide-react";
import { useOffert } from "@/components/OffertModal";
import { trackContact } from "@/lib/metaPixel";

/**
 * Sticky CTA-bar som visas längst ner på mobil efter att användaren
 * scrollat förbi hero-sektionen. Döljs på desktop.
 */
export default function StickyMobileCta() {
  const { openOffert } = useOffert();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Visa efter 600px scroll (ungefär förbi hero)
      setVisible(window.scrollY > 600);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-t border-border shadow-[0_-4px_12px_rgba(0,0,0,0.08)] px-4 py-3 safe-area-bottom">
      <div className="flex items-center gap-3 max-w-lg mx-auto">
        <button
          onClick={() => openOffert("sticky-mobile-cta")}
          className="flex-1 bg-rose hover:bg-rose-dark text-white font-medium py-3 px-4 rounded-lg text-sm transition-colors"
        >
          Ta kontakt
        </button>
        <a
          href="tel:+46841026111"
          onClick={() => trackContact({ content_name: "Sticky Mobile CTA", method: "phone" })}
          className="flex items-center justify-center gap-1.5 bg-navy text-white font-medium py-3 px-4 rounded-lg text-sm transition-colors hover:bg-navy/90"
        >
          <Phone className="w-4 h-4" />
          Ring oss
        </a>
      </div>
    </div>
  );
}
